

    var echarts = require('../echarts');

    require('../component/parallel');

    require('./parallel/ParallelSeries');
    require('./parallel/ParallelView');

    echarts.registerVisual(require('./parallel/parallelVisual'));




//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/chart/parallel.js
// module id = qbKW
// module chunks = 5